import { getApiUrl } from "../config/api";

/**
 * Group Service
 * Handles all group-related API calls
 */

export const groupService = {
  /**
   * Get all groups for a specific user
   */
  async getAllGroups(userId) {
    if (!userId) {
      throw new Error('User ID is required to fetch groups');
    }
    const response = await fetch(getApiUrl(`/api/groups/user/${userId}`));
    if (!response.ok) {
      throw new Error(`Failed to fetch groups: ${response.status}`);
    }
    return response.json();
  },

  /**
   * Get a specific group by ID
   */
  async getGroup(id) {
    const response = await fetch(getApiUrl(`/api/groups/${id}`));
    if (!response.ok) {
      throw new Error(`Failed to fetch group: ${response.status}`);
    }
    return response.json();
  },

  /**
   * Create a new group
   */
  async createGroup(userId, name) {
    if (!userId) {
      throw new Error('User ID is required to create group');
    }
    const response = await fetch(getApiUrl('/api/groups'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, name }),
    });
    if (!response.ok) {
      throw new Error(`Failed to create group: ${response.status}`);
    }
    return response.json();
  },

  /**
   * Update group name
   */
  async updateGroup(userId, id, name) {
    if (!userId) {
      throw new Error('User ID is required to update group');
    }
    const response = await fetch(getApiUrl(`/api/groups/${id}`), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, name }),
    });
    if (!response.ok) {
      throw new Error(`Failed to update group: ${response.status}`);
    }
    return response.json();
  },

  /**
   * Delete a group (does not delete RFQs)
   */
  async deleteGroup(userId, id) {
    if (!userId) {
      throw new Error('User ID is required to delete group');
    }
    const response = await fetch(getApiUrl(`/api/groups/${id}?userId=${userId}`), {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`Failed to delete group: ${response.status}`);
    }
  },

  /**
   * Add an RFQ to a group
   */
  async addRFQToGroup(userId, groupId, rfqNumber) {
    if (!userId) {
      throw new Error('User ID is required to add RFQ to group');
    }
    const response = await fetch(getApiUrl(`/api/groups/${groupId}/rfqs`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId, rfqNumber }),
    });
    if (!response.ok) {
      throw new Error(`Failed to add RFQ to group: ${response.status}`);
    }
    return response.json();
  },

  /**
   * Remove an RFQ from a group
   */
  async removeRFQFromGroup(userId, groupId, rfqNumber) {
    if (!userId) {
      throw new Error('User ID is required to remove RFQ from group');
    }
    const response = await fetch(getApiUrl(`/api/groups/${groupId}/rfqs/${rfqNumber}?userId=${userId}`), {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`Failed to remove RFQ from group: ${response.status}`);
    }
    return response.json();
  },
};
